export const OC_CHECKOUT = {
  desktop: `
  <div class="cui cui-grid">
    <div class="cui-row no-gaps" style="border-bottom: 1px solid #E8E8E8;">
      <div class="cui-container">
        <div style="display: flex; justify-content: space-between; width: 100%; padding: 2px 0;">
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16 -spacing--top-16">
            <div class="cui-skeleton__item" style="width: 126px; height: 36px"></div>
          </div>
          <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--top-24">
            <div class="cui-skeleton-paragraph__content" style="width: 80px;">
              <div class="cui-skeleton__item cui-skeleton__description"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cui-container -spacing--top-24 -spacing--bottom-80">
      <div class="display-none display-xl-block" style="min-height: 24px;"></div>

      <div class="cui-row">
        <div class="cui-col-xl-8 cui-col-xxl-8 cui-col-lg-12 col-order-2 col-order-xl-1 col-order-xll-2">
          <div class="display-xl-none" style="min-height: 48px;"></div>
          
          <div class="cui-row">
            <div class="cui-col-lg-12>">
              <div class="cui-skeleton-heading -size--medium -resolution--desktop -spacing--bottom-32" style="max-width: 60%">
                <div class="cui-skeleton-input__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="cui-row">
            <div class="cui-col-xl-6 cui-col-lg-5 cui-col-md-6">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-64">
                <div class="cui-skeleton__item" style="width: 100%; height: 354px"></div>
              </div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-64">
                <div class="cui-skeleton__item" style="width: 100%; height: 354px"></div>
              </div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-64">
                <div class="cui-skeleton__item" style="width: 100%; height: 354px"></div>
              </div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-64">
                <div class="cui-skeleton__item" style="width: 100%; height: 354px"></div>
              </div>
              <div class="cui-skeleton-button -size--large -spacing--bottom-40">
                <div class="cui-skeleton-button__content" style="width: 180px;">
                  <div class="cui-skeleton__item cui-skeleton-button__button"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="cui-row">
            <div class="cui-col-lg-12>">
              <div class="cui-skeleton-heading -size--medium -resolution--desktop -spacing--bottom-24" style="max-width: 60%">
                <div class="cui-skeleton-input__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
                </div>
              </div>
              <div class="cui-skeleton-heading -size--medium -resolution--desktop" style="max-width: 60%">
                <div class="cui-skeleton-input__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="cui-col-xl-4 cui-col-xxl-4 cui-col-lg-12 col-order-1 col-order-xl-1 col-order-xll-1">
          <div class="cui-skeleton-heading -size--medium -resolution--desktop -spacing--bottom-24">
            <div class="cui-skeleton-input__content" style="width: 100%; max-width: 60%;">
              <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
            </div>
          </div>

          <div class="-spacing--bottom-24" style="border-bottom:1px solid #E8E8E8;">
            <div class="-spacing--bottom-24" style="display:flex; justify-content: space-between;">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 140px; height: 24px"></div>
              </div>
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 120px; height: 24px"></div>
              </div>
            </div>
            <div class="-spacing--bottom-24" style="display: flex; justify-content: space-between;">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 140px; height: 24px"></div>
              </div>
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 120px; height: 24px"></div>
              </div>
            </div>
            <div class="-spacing--bottom-24" style="display: flex; justify-content: space-between;">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 140px; height: 24px"></div>
              </div>
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 120px; height: 24px"></div>
              </div>
            </div>
            <div class="-spacing--bottom-24" style="display: flex; justify-content: space-between;">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 140px; height: 24px"></div>
              </div>
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 120px; height: 24px"></div>
              </div>
            </div>
          </div>

          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
            <div class="cui-skeleton__item" style="width: 160px; height: 24px"></div>
          </div>

          <div class="display-none display-xl-block" style="padding-top:16px;">
            <div class="cui-skeleton-button -size--large">
              <div class="cui-skeleton-button__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton-button__button"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="cui-skeleton-rectangle -is--block display-none display-md-block">
        <div class="cui-skeleton__item" style="width: 100%; height: 128px"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block display-md-none">
        <div class="cui-skeleton__item" style="width: 100%; height: 220px"></div>
      </div>
    </div>

    <div class="cui-container -spacing--top-40 -spacing--bottom-32">
      <div style="display: flex; justify-content: center; width: 100%; gap: 24px;">
        <div class="cui-skeleton__item" style="width: 120px; height: 32px"></div>
        <div class="cui-skeleton__item" style="width: 120px; height: 32px"></div>
        <div class="cui-skeleton__item" style="width: 120px; height: 32px"></div>
      </div>

      <div class="-spacing--top-48" style="display: flex; justify-content: center; width: 100%;">
        <div class="cui-skeleton__item" style="width: 80px; height: 24px"></div>
      </div>

      <div class="-spacing--top-8" style="display: flex; justify-content: center; width: 100%; gap: 16px; flex-wrap: wrap;">
        <div class="cui-skeleton__item" style="width: 80px; height: 20px"></div>
        <div class="cui-skeleton__item" style="width: 80px; height: 20px"></div>
        <div class="cui-skeleton__item" style="width: 80px; height: 20px"></div>
        <div class="cui-skeleton__item" style="width: 80px; height: 20px"></div>
        <div class="cui-skeleton__item" style="width: 80px; height: 20px"></div>
        <div class="cui-skeleton__item" style="width: 80px; height: 20px"></div>
      </div>
    </div>
  </div>
  `
};
